var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-steps',{attrs:{"active":_vm.active,"finish-status":"success","align-center":""}},_vm._l((_vm.stepList),function(item,index){return _c('el-step',{key:index,staticClass:"font-title",attrs:{"title":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }